import { StaticPageLayout } from '@/components/layout/StaticPageLayout';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export function DemoPage() {
 const navigate = useNavigate();

 return (
  <StaticPageLayout title='Demo Mode'>
   <div className='bg-primary/5 border border-primary/20 p-8 text-center'>
    <h2 className='text-2xl font-bold mb-4 font-mono uppercase'>
     Experience the System
    </h2>
    <p className='text-muted-foreground mb-8 max-w-lg mx-auto'>
     Try a limited version of the interview interface without creating an
     account. You will have 15 minutes to complete a single algorithmic
     challenge.
    </p>
    <Button
     onClick={() => navigate('/interview')}
     className='rounded-none font-mono uppercase text-lg px-8 py-6'
    >
     Launch Simulation
    </Button>
   </div>

   <div className='mt-12 text-sm text-muted-foreground text-center'>
    <p>
     Authentication not required for demo mode. Progress will not be saved.
    </p>
   </div>
  </StaticPageLayout>
 );
}
